import MDBox from "components/MDBox";
import DashboardLayout from "layouts/dashboardpages/DashboardLayout.js";
import DashboardNavbar from "layouts/Navbars/DashboardNavbar/index.js";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Config from "../../config.js";
import { useEffect, useState } from "react";
import { Backdrop ,CircularProgress} from "@mui/material";
import { useTranslation } from "react-i18next";

function LogOut() {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();
  const BASE = Config.BASE;
  const TOKEN = window.localStorage.getItem('token');

  const logOut = async (data) => {
    setIsLoading(true);
    const res = await axios({
      // Endpoint to send files
      url: BASE + "api/logout",
      method: "POST",
      data: { id: localStorage.getItem('id') },
      headers: {
        Authorization: `Bearer ${TOKEN}`,
        function: Config.FUNCTION_KEY
      },
      // Attaching the form data
    }).then((res) => {
      (res.status == 200 && res.data.status == 1) ?
        (
          setIsLoading(false), localStorage.removeItem('token'), localStorage.removeItem('id'), localStorage.removeItem('type'), localStorage.removeItem('privileges'),
          navigate('/admin/login')
        )
        :
        (
          setIsLoading(false), localStorage.removeItem('token'), localStorage.removeItem('id'), localStorage.removeItem('type'), localStorage.removeItem('privileges'), navigate('/admin/login')
        );
    }).catch((err) => {
      setIsLoading(false), localStorage.removeItem('token'), localStorage.removeItem('id'), localStorage.removeItem('type'), localStorage.removeItem('privileges'), navigate('/admin/login')
    });
  };

  useEffect(() => {
    logOut();
  }, []);

  return (
    <DashboardLayout>
    <DashboardNavbar />
    <Backdrop sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }} open={isLoading}><CircularProgress color="inherit" /></Backdrop>
    <MDBox className="logout">{t("logoutNote")}</MDBox>
  </DashboardLayout>
  );
}

export default LogOut;
